/* istanbul ignore file */
import React from 'react';
import { EnumDropdown, DefaultDropdownProps } from 'framework/form';
import { PAID_LEAVE_BALANCES } from 'domain/people/employee/contracts/shared/employeeContractsService';

const PaidLeaveBalanceDropdown = (props: Omit<DefaultDropdownProps, 'options'>) => (
  <EnumDropdown {...props} options={PAID_LEAVE_BALANCES} placeholder="Select paid leave balance" />
);

export default PaidLeaveBalanceDropdown;
